import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.25 10.35v5.4h-5.4a.6.6 0 0 1-.6-.6v-5.4h5.4a.6.6 0 0 1 .6.6M8.25 15.75h2.25M2.25 9.75V7.5M4.5 2.25H2.85a.6.6 0 0 0-.6.6V4.5M10.5 2.25h-3M15.75 7.5v3M13.5 2.25h1.65a.6.6 0 0 1 .6.6V4.5M13.5 15.75h1.65a.6.6 0 0 0 .6-.6V13.5M8.25 7.5h2.25v2.25"
    }, null, -1)
  ]))]))
}
export default { render: render }